import { Attachment, BaseModel } from './common'

export enum UserType {
  NORMAL = 'normal',
  ADMIN = 'admin',
  GOD = 'god'
}

export interface UserArpMediaStatistics {
  songMintCount: number
  sampleMintCount: number
  stemMintCount: number
  sampleRemixCount: number
  stemRemixCount: number
}

export interface User extends BaseModel {
  walletAddress: string
  displayName: string | null
  email: string | null
  verifiedEmail: string | null
  hasVerifiedEmail: boolean
  bio: string | null
  openSeaHandle: string | null
  twitterHandle: string | null
  soundCloudHandle: string | null
  profilePicture: Attachment | null
  arpMediaStatistics?: UserArpMediaStatistics
  type: UserType
}
